// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isTuesday as fn } from "../isTuesday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isTuesday = convertToFP(fn, 1);

// Fallback for modularized imports:
export default isTuesday;
